//-------------------------------------------------- DEPRECATED---------------------------------------------
// import React from 'react';
import LineItem from './LineItem';

// const Items= (props) =>
// let counter=0;

// if(counter==props.items.length)props.noItems(false) ;

// export default Items;
import React, { Component } from 'react';

export default class Items extends Component {
  componentDidMount() {}
  render() {
    return (
      <div>
        {this.props.items.map((item, index) => {
          let match = this.props.query;

          let re = new RegExp(match, 'gi');
          if (item.name.match(re) || this.props.query === '')
            return (
              <LineItem
                description={item.description}
                name={item.name}
                isNotAvailable={item.isNotAvailable ? true : false}
                price={item.price}
                click={() => this.props.click(item)}
                key={index}
              />
            );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Items.js